var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingContactButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15751",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15751",
    transform: "translate(-378 -581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message",
    d: "M21.941,4H5.519A3.519,3.519,0,0,0,2,7.519v11.73a3.519,3.519,0,0,0,3.519,3.519H21.941a3.519,3.519,0,0,0,3.519-3.519V7.519A3.519,3.519,0,0,0,21.941,4ZM21.46,6.346l-6.9,6.9a1.173,1.173,0,0,1-1.666,0L6,6.346Zm1.654,12.9a1.173,1.173,0,0,1-1.173,1.173H5.519a1.173,1.173,0,0,1-1.173-1.173V8l6.9,6.9a3.519,3.519,0,0,0,4.974,0l6.9-6.9Z",
    transform: "translate(380 584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10551",
    "data-name": "\\u9577\\u65B9\\u5F62 10551",
    width: 32,
    height: 32,
    transform: "translate(378 581)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingContactButton);
export default __webpack_public_path__ + "static/media/settingContactButton.d2be1afc28bbd8dc952236460f2eba63.svg";
export { ForwardRef as ReactComponent };